import {
  configApiRef,
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { createDeployV3Api, deployV3ApiRef } from './api';
import { rootRouteRef } from './routes';

export const deployV3Plugin = createPlugin({
  id: 'deploy-v3',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: deployV3ApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        createDeployV3Api({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * The Entity Deploy tab — the component that wires into the entity page's
 * `<EntitySwitch>` layout.
 *
 * Exposed as a plain component extension (not routable). The entity layout
 * provides its own routing context via `<EntityLayout.Route>`, so the
 * v3 page doesn't need its own route binding. If/when we add a top-level
 * approval-inbox page (the original sprint-2-3 plan), that page should
 * use `createRoutableExtension({ mountPoint: rootRouteRef })` and be
 * mounted with `<Route path="/deploy-v3" element={<...>} />` in App.tsx.
 */
export const EntityDeployV3Content = deployV3Plugin.provide(
  createComponentExtension({
    name: 'EntityDeployV3Content',
    component: {
      lazy: () =>
        import('./components/EntityDeployPage').then(m => m.EntityDeployPage),
    },
  }),
);

/**
 * ApprovalInboxPage — the top-level routable extension. Mounted at
 * /deploy-v3 in packages/app/src/App.tsx. Binds rootRouteRef.
 */
export const DeployV3InboxPage = deployV3Plugin.provide(
  createRoutableExtension({
    name: 'DeployV3InboxPage',
    component: () =>
      import('./components/ApprovalInboxPage/ApprovalInboxPage').then(
        m => m.ApprovalInboxPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
